import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ISearchTraysResultPayload } from '../../../types';

/**
 * This key is used to track useTrayListQuery
 */
export const TRAY_LIST_QUERY_KEY = 'tray-list-query-key';

/**
 * This hook fetches the tray list.
 */
export const useTrayListQuery = (payload: ISearchTraysResultPayload) => {
  const { limit, page, filter, search } = payload;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [TRAY_LIST_QUERY_KEY, page, limit, filter, search],
    networkMode: 'always',
    retry: false,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getTrays({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * (limit || 20);

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
